import { useEffect, useState, useContext } from "react";
import { navigate } from "@reach/router";

import { firebaseFetchUserProfile } from "../firebase/user";
import { firebaseAuthUser } from "../firebase/auth";
import { AuthStoreContext } from "../contexts";

export default function useUserProfileCheck(props = {}) {
  /**
  |--------------------------------------------------
  | Contexts
  |--------------------------------------------------
  */
  const authStore = useContext(AuthStoreContext);

  /**
  |--------------------------------------------------
  | Props
  |--------------------------------------------------
  */
  const { dealerID, factoryID, onlyAdmin } = props;

  /**
  |--------------------------------------------------
  | States
  |--------------------------------------------------
  */
  const [loading, setLoading] = useState(true);
  const [profile, setProfile] = useState({});

  /**
  |--------------------------------------------------
  | Hook
  |--------------------------------------------------
  */

  useEffect(() => {
    const isFactoryUserNotNavigateInFactoryZone = (userProfile) => {
      return userProfile.factory && !factoryID;
    };

    const isFactoryUserNotNavigateInOwnFactory = (userProfile) => {
      return userProfile.factory && userProfile.factory !== factoryID;
    };

    const isDealerUserNotNavigateInOwnDealer = (userProfile) => {
      return userProfile.dealer && userProfile.dealer !== dealerID;
    };

    async function checkProfile() {
      try {
        const user = await firebaseAuthUser();
        const params = new URLSearchParams(window.location.search);
        const redirect = params.get("redirect");
        if (!user) {
          if (redirect !== null) {
            navigate(`/signin?redirect=${redirect}`);
          } else {
            navigate(`/signin`);
          }
          return;
        }

        const userProfile = await firebaseFetchUserProfile(user.uid);
        setProfile(userProfile);

        authStore.setAuthUser(user);
        authStore.setAuthUserProfile(userProfile);

        if (userProfile.role === "superadmin") {
          setLoading(false);
          return;
        }

        /**
         * CHECK FACTORY
         */
        if (isFactoryUserNotNavigateInFactoryZone(userProfile)) {
          navigate(`/${userProfile.dealer}/${userProfile.factory}`);
          return;
        }

        if (factoryID) {
          if (isFactoryUserNotNavigateInOwnFactory(userProfile)) {
            navigate(`/${userProfile.dealer}/${userProfile.factory}`);
            return;
          }

          if (userProfile.factory && factoryID === "") {
            navigate(`/${userProfile.dealer}/${userProfile.factory}`);
            return;
          }
        }

        /**
         * CHECK DEALER
         */
        if (dealerID) {
          if (isDealerUserNotNavigateInOwnDealer(userProfile)) {
            navigate(`/${userProfile.dealer}`);
            return;
          }
        }

        /**
        |--------------------------------------------------
        | CHECK ROLE
        |--------------------------------------------------
        */
        if (onlyAdmin) {
          if (userProfile.role !== "admin") {
            navigate(`/`);
            return;
          }
        }

        setLoading(false);
      } catch (error) {
        console.error(error);
      }
    }

    checkProfile();
  }, [dealerID, factoryID, onlyAdmin, authStore]);

  /**
  |--------------------------------------------------
  | Return
  |--------------------------------------------------
  */
  return [loading, profile];
}
